import React from 'react'
// libs
import styled from 'styled-components'
// components
import Tooltip from '@mui/material/Tooltip'
import PopoverModal from 'components/UI/PopoverModal'
// views
import { Row } from '../../../views'
// icons
import MenuItemOrigin from '@mui/material/MenuItem'
import DotsIconOrigin from '@mui/icons-material/MoreHorizOutlined'
// utils
import { size } from 'polished'

// styled
const DotsIcon = styled(DotsIconOrigin)`
  && {
    cursor: pointer;
    ${size('18px')};
  }
`

const RowValue = styled.div`
  max-height: 100%;
  overflow: hidden;
  line-height: 17px;

  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
`

const MODAL_PROPS = {
  anchorOrigin: {
    vertical: 'center' as const,
    horizontal: 'center' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const
  }
}

const subOptions = ['Edit Options']

interface Props {
  color: string
  isSelect: boolean
  isSelected: boolean
  showOptions: boolean
  rowValueLabel: string
  onSubOptionClick: ({
    event,
    option,
    isSelect,
    closePopup
  }: {
    event: React.MouseEvent<HTMLElement>
    option: string
    isSelect: boolean
    closePopup: () => void
  }) => void
}

const Select: React.FC<Props> = ({ color, isSelect, isSelected, showOptions, rowValueLabel, onSubOptionClick }) => {
  const options = subOptions.filter((option) => !(option === 'Select Value' && !rowValueLabel))

  return (
    <Row isSelect color={color} showOptions={showOptions} isSelected={isSelected}>
      {showOptions && (
        <PopoverModal {...MODAL_PROPS} trigger={<DotsIcon />}>
          {({ closePopup }) => {
            return options.map((option) => (
              <MenuItemOrigin
                key={option}
                onClick={(event) =>
                  onSubOptionClick({
                    event,
                    option,
                    isSelect,
                    closePopup
                  })
                }>
                <span>{option}</span>
              </MenuItemOrigin>
            ))
          }}
        </PopoverModal>
      )}

      {rowValueLabel ? (
        <Tooltip title={rowValueLabel} disableHoverListener={!rowValueLabel}>
          <RowValue>{rowValueLabel}</RowValue>
        </Tooltip>
      ) : (
        'Select'
      )}
    </Row>
  )
}

export default Select
